export default {
  country_locale: 'sv-SE',
  wia_contact_links: {
    BK: 'https://www.bauknecht.se/Kundservice/Kontakta-oss',
    ID: 'https://www.indesit.se/Indesit-Support/Boka-reparation',
    WP: 'https://www.whirlpool.se/support/kontakta-oss'
  },
  wia_title: 'Onlineportal för självservice',
  wia_need_help: 'Jag önskar hjälp med',
  wia_model_name: 'Modellnamnet är',
  wia_back: '< ändra',
  wia_confirm: 'Bekräfta',
  wia_issue_title: 'Vad upplever du för problem?',
  wia_issue_concern: 'Mitt problem gäller',
  wia_issue_specific: 'Specificera problemet',
  wia_possible_solution: 'Möjlig lösning',
  wia_solved_issue: 'Blev problemet löst?',
  wia_closed: 'Stäng X',
  wia_feedback_ok: 'Ja',
  wia_find_another_solution: 'Finn en annan lösning',
  wia_feedback_title: 'Vi är glada att problemet löstes!',
  wia_feedback_text1: 'Besök vår webbutik och hitta specialerbjudanden',
  wia_feedback_text2: 'Lär dig mer om våra senaste produkter',
  wia_smile_up_popup_text1: 'Läs mer om utökade säkerhetstjänster',
  wia_smile_down_popup_title: 'Behöver du mer hjälp?',
  wia_smile_down_popup_text1: 'Gå till nästa steg',
  wia_smile_down_popup_or_text: 'eller',
  wia_smile_down_popup_text2: 'Boka ett servicebesök',
  wia_need_more_help: 'Behöver du mer hjälp?',
  wia_optional_label: '(valfritt)',
  wia_no_solution: 'Tyvärr finns det inga enkla självservice lösningar för ditt problem. Klicka här för att få hjälp',
  wia_all_solution: 'Alla resultat',
  wia_all_categories: 'Alla kategorier',
  wia_seo_l1_issue: 'Alla fel per kategori',
  wia_seo_wp_country_name: 'SE',
  wia_seo_bk_country_name: 'SE',
  wia_seo_hp_country_name: 'SE',
  wia_seo_id_country_name: 'SE',
  wia_seo_wp_meta_title: 'Problem och lösningar',
  wia_seo_bk_meta_title: 'Problem och lösningar',
  wia_seo_hp_meta_title: 'Problem och lösningar',
  wia_seo_id_meta_title: 'Problem och lösningar',
  wia_seo_wp_meta_description_home: 'Felsök produkten med Whirlpools tekniska onlineverktyg',
  wia_seo_bk_meta_description_home: 'Felsök produkten med Bauknechts tekniska onlineverktyg',
  wia_seo_hp_meta_description_home: 'Felsök produkten med Hotpoints tekniska onlineverktyg',
  wia_seo_id_meta_description_home: 'Felsök produkten med Indesits tekniska onlineverktyg',
  wia_issue_search: 'Vad är problemet?',
  wia_issue_description: 'Beskriv kortfattat huvudproblemet med din produkt',
  wia_issue_placeholder: 'T.ex: vatten läcker underifrån',
  wia_issue_generic_macro_category: 'Allmänt',
  wia_issue_no_results: 'Inga resultat hittades!',
  wia_issue_search_label: 'Sök',
  wia_related_solution: 'Relaterade lösningar',
  wia_seo_wp_meta_description: 'Lös din produkts problem med bara några klick med hjälp av onlineverktyget från Beko Europe Sverige',
  wia_seo_bk_meta_description: 'Lös din produkts problem med bara några klick med hjälp av onlineverktyget från Bauknecht Sverige',
  wia_seo_hp_meta_description: 'Lös din produkts problem med bara några klick med hjälp av onlineverktyget från Hotpoint Sverige',
  wia_seo_id_meta_description: 'Lös din produkts problem med bara några klick med hjälp av onlineverktyget från Indesit Sverige'
}
